import { TreeLevel } from 'components/DependencyTrees/CustomTreeLevel';
import { stripHtmlTags } from 'utils/stripHtmlTags';

export const gapsAuditLevels: TreeLevel<any>[] = [
  {
    // BRU
    groupBy: (i) => i.bru_key_value,
    getKey: (group) => `bru-${group}`,
    getLabel: (i) => i.bru_key_value
  },

  {
    // GAP
    groupBy: (i) => String(i.gap_id),
    getKey: (group) => `gap-${group}`,
    getLabel: (i) => stripHtmlTags(i.gap_description)
  },

  {
    // AUDIT
    groupBy: (i) => String(i.afg_description),
    getKey: (group) => `audit-${group}`,
    getLabel: (i) => stripHtmlTags(i.afg_description)
  },

  {
    // SOLUTION
    groupBy: (i) => String(i.sol_description),
    getKey: (group) => `solution-${group}`,
    getLabel: (i) => stripHtmlTags(i.sol_description)
  }
];
